import React from 'react';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { TStepTwoForm } from '@/features/user/register/stepTwo/types';
import { Stack } from '@mui/material';
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import { Grid, } from "@mui/material";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const StepTwoForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }: TStepTwoForm
): any => {
    const [t] = useTranslation();

    const formFields: any[] = [
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_street')}
                    name="calle"
                    required={required.calle}
                />
        },
        {
            field:
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="center"
                    alignItems="baseline"
                    spacing={2}
                >
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label={t('step_two.label_ext_num')}
                        name="no_exterior"
                        required={required.no_exterior}
                    />

                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label={t('step_two.label_int_num')}
                        name="no_interior"
                        required={required.no_interior}
                    />
                </Stack>
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_colony')}
                    name="colonia"
                    required={required.colonia}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_street_reference')}
                    name="referencia"
                    required={required.referencia}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_municipality')}
                    name="municipio"
                    required={required.municipio}
                />

        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_locality')}
                    name="localidad"
                    required={required.localidad}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('step_two.label_state')}
                    name="estado"
                    required={required.estado}
                />
        },
        {
            field:
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="center"
                    alignItems="baseline" spacing={2}
                >
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label={t('step_two.label_country')}
                        name="pais"
                        required={required.pais}
                    />

                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label={t('step_two.label_zip_code')}
                        name="codigo_postal"
                        required={required.codigo_postal}
                    />
                </Stack>
        }
    ]

    const modalProps: any = {
        hasMenuItem: true,
        label: t('step_two.title'),
        title: t('step_two.title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit }) => (
                        <>
                            {loading && <SimpleSpinner/>}
                            {!loading &&
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container spacing={2}>
                                        {formFields.map((item, idx) => (
                                            <Grid item md={4} sm={6} xs={12} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <LoadingButton
                                        sx={{ mt: 3, mr: 1 }}
                                        //fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        loading={submitting}
                                    >
                                        {t('common.save')}
                                    </LoadingButton>
                                </form>
                            }
                        </>
                    )}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>
    );
};

export default StepTwoForm;
